import { useNavigate } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ShoppingCart, Store } from "lucide-react";

/**
 * Popup di conferma dopo l'aggiunta di un corso al carrello.
 * - Pulsante 1: Continua lo shopping (chiude e resta nella pagina)
 * - Pulsante 2: Vai al carrello (reindirizza a /partner/carrello)
 */
export default function CartAddedDialog() {
  const { addedCourse, clearAdded } = useCart();
  const navigate = useNavigate();

  const open = !!addedCourse;
  const close = () => clearAdded();
  const goToCart = () => { clearAdded(); navigate("/partner/carrello"); };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) close(); }}>
      <DialogContent className="max-w-sm sm:max-w-md" data-testid="cart-added-dialog">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-emerald-100 border border-emerald-200 flex items-center justify-center mb-2">
            <CheckCircle2 className="w-6 h-6 text-emerald-600" />
          </div>
          <DialogTitle className="text-left font-display">
            Corso aggiunto al carrello
          </DialogTitle>
        </DialogHeader>
        <div className="text-sm text-slate-600">
          {addedCourse?.title && (
            <div className="mb-2 font-semibold text-slate-900" data-testid="cart-added-title">{addedCourse.title}</div>
          )}
          Il corso è stato aggiunto al carrello. Vuoi continuare lo shopping oppure andare al carrello?
        </div>
        <DialogFooter className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 mt-4">
          <Button variant="outline" onClick={close} data-testid="cart-added-continue" className="w-full sm:w-auto">
            <Store className="w-4 h-4 mr-1" /> Continua lo shopping
          </Button>
          <Button onClick={goToCart} data-testid="cart-added-go-to-cart" className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-white">
            <ShoppingCart className="w-4 h-4 mr-1" /> Vai al carrello
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
